<template>
  <div class="directories">
    <h1>
      directories
    </h1>
  </div>
</template>

<script>
export default {
  name: 'directories'
}
</script>

<style>

</style>